module.exports = __webpack_public_path__ + "d69cea220c6e9b8a97d33c0e66b5854b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-15.png
// module id = 2489
// module chunks = 0